import React, {useState} from "react";
import Social from "./social";
import Heading from "./heading";

export default function Demo(){
    
    const [text, changeText] = useState("")
    const [results, changeResult] = useState([])
    const [resultsAlpha, changeResultAlpha] = useState([])
    const [resultsBravo, changeResultBravo] = useState([])
    const [resultsCharlie, changeResultCharlie] = useState([])
    let syn = generateColorDictionary()

    const searchParams = new URLSearchParams(window.location.search);
    const parameterValue = searchParams.get('key1');

    function feedback(){
        const dataToSend = {key1: parameterValue};
        const queryString = new URLSearchParams(dataToSend).toString();
        const url = `/feedback?${queryString}`;
        window.location.href = url
    }
    const handleChange = (event) => {
        changeText(event.target.value);
    };
    
    function getRandomColor() {
        // Generate random values for red, green, and blue components
        const red = Math.floor(Math.random() * 256);
        const green = Math.floor(Math.random() * 256);
        const blue = Math.floor(Math.random() * 256);
        
        // Return the RGB color string
        return `(${red},${green},${blue})`;
      }
      
      // Function to generate the dictionary
      function generateColorDictionary() {
        const dictionary = {};
      
        // Add lowercase letters
        for (let i = 97; i <= 122; i++) {
          const letter = String.fromCharCode(i);
          dictionary[letter] = getRandomColor();
        }
      
        // Add uppercase letters
        for (let i = 65; i <= 90; i++) {
          const letter = String.fromCharCode(i);
          dictionary[letter] = getRandomColor();
        }
      
        // Add numbers 0-9
        for (let i = 0; i <= 9; i++) {
          dictionary[i] = getRandomColor();
        }
      
        return dictionary;
      }

    const generate = () => {
        
        const resultsBuffer = []
        const alphaBuffer = []
        const bravoBuffer = []
        const charlieBuffer = []

        Array.from(text).forEach(char => {
            //adding new entry to buffer
            resultsBuffer.push(`rgb${syn[char]}`)
            //changing results
            changeResult(resultsBuffer)
        });

        syn = generateColorDictionary()

        Array.from(text).forEach(char => {
            
            //adding new entry to buffer
            alphaBuffer.push(`rgb${syn[char]}`)
            //changing results
            changeResultAlpha(alphaBuffer)
        });

        syn = generateColorDictionary()

        Array.from(text).forEach(char => {
            
            //adding new entry to buffer
            bravoBuffer.push(`rgb${syn[char]}`)
            //changing results
            changeResultBravo(bravoBuffer)
        });

        syn = generateColorDictionary()

        Array.from(text).forEach(char => {
            
            //adding new entry to buffer
            charlieBuffer.push(`rgb${syn[char]}`)
            //changing results
            changeResultCharlie(charlieBuffer)
        });
    }

    return(
        <>
            <Heading/>
                <h1 className="demo-heading">Enter text below to see how Colorantí will encrypt your data</h1>
                <div className="demo-input-container">
                    <input className="color-text" placeholder="ENTER TEXT" value={text} onChange={handleChange}></input>
                    <button className="login-button" onClick={generate}>GENERATE COLORANTÍ</button>
                </div>
                <div className="results-container">
                    {results.map((color, index) => (
                        <div key={index} className="demo-result" style={{ backgroundColor: color }}></div>
                    ))}
                </div>
                <div className="demo-input-container">
                    <button to="/feedback" onClick={feedback} className="feedback">GIVE US FEEDBACK HERE</button>
                </div>
                <h1 className="demo-heading">Three different examples of our <i>Randomized Hexa-Chroma Match System</i></h1>
                <div className="demo-result-lang">
                    <h1 className="demo-heading" style={{marginBottom: '0%', minWidth: '150px'}}>ALPHA</h1>
                    <div className="demo-result-container">
                        {resultsAlpha.map((color, index) => (
                            <div key={index} className="demo-result" style={{ backgroundColor: color }}></div>
                        ))}
                    </div>
                </div>
                <div className="demo-result-lang">
                    <h1 className="demo-heading" style={{marginBottom: '0%', minWidth: '150px'}}>BRAVO</h1>
                    <div className="demo-result-container">
                        {resultsBravo.map((color, index) => (
                            <div key={index} className="demo-result" style={{ backgroundColor: color }}></div>
                        ))}
                    </div>
                </div>
                <div className="demo-result-lang">
                    <h1 className="demo-heading" style={{marginBottom: '0%', minWidth: '150px'}}>CHARLIE</h1>
                    <div className="demo-result-container">
                        {resultsCharlie.map((color, index) => (
                            <div key={index} className="demo-result" style={{ backgroundColor: color }}></div>
                        ))}
                    </div>
                </div>

            <Social/>
        </>
    )
}
